import React, { CSSProperties } from "react";
import { EnrichedSwarovskiProductFrontendProductAggregatedReviews } from "@swo/storefront";
import { css } from "@emotion/react";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { StarSvg } from "./PDP_SingleImageCarousel/PDPReviewSummary";
import { FONTS, fontSize } from "../../styles/fonts";
import cn from "classnames";

export const PDPReviewsHistorgramBar: React.FC<{
  starValue: number;
  data: NonNullable<EnrichedSwarovskiProductFrontendProductAggregatedReviews>;
  onClick: () => void;
}> = ({ starValue, data, onClick }) => {
  const percentage = data.reviews.filter(review => review.rating === starValue).length / data.reviews.length;
  const reviewsCount = data.reviews.filter(review => review.rating === starValue).length;

  return (
    <li
      className={cn("u-grid u-gap-2", reviewsCount === 0 && "disabled")}
      css={[
        fontSize.x2,
        css`
          grid-template-columns: auto 1fr 1.2em;
          align-items: center;

          cursor: pointer;

          &.disabled {
            cursor: not-allowed;
          }
        `,
      ]}
      onClick={reviewsCount > 0 ? onClick : undefined}
    >
      <button
        className="u-ta-right"
        css={[
          FONTS.SwarovskiFutura300,
          fontSize.x2,
          css`
            [disabled] {
              cursor: not-allowed;
            }
          `,
        ]}
        onClick={reviewsCount > 0 ? onClick : undefined}
        disabled={reviewsCount === 0}
      >
        {starValue}

        <span className="u-ml-1">
          <StarSvg className="full" />
        </span>
      </button>

      <div
        style={
          {
            "--percentage": `${percentage * 100}%`,
          } as CSSProperties
        }
        css={css`
          height: 12px;
          background-color: ${CSS_COLORS.GrayLight2024};
          align-self: center;

          &:hover {
            //
          }

          position: relative;
          &:before {
            content: "";

            position: absolute;
            left: 0;
            top: 0;
            width: var(--percentage);
            height: 100%;

            background-color: ${CSS_COLORS.GreenDark};
          }
        `}
      />

      <span css={FONTS.SwarovskiFutura300} className="u-ta-right">
        {reviewsCount}
      </span>
    </li>
  );
};
